// import { Spin } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useForm, FormProvider } from 'react-hook-form';
import { useQuery } from 'react-query';

import Content from './Content';
import { FilterRevenueDTO } from './filter-revenue.dto';

import LayoutContent from '@/layout/Content';
import revenueService from '@/services/revenue.service';
import { handleMessageError } from '@/util/handleMessageError';

const Revenue = () => {
    const methods = useForm<FilterRevenueDTO>();

    const [params, setParams] = useState<any>({
        day: moment().format('YYYY/MM/DD'),
    });
    const {
        isLoading,
        data: revenue,
        refetch,
    } = useQuery(['revenue'], () => revenueService.getRevenueReport(params), {
        enabled: !!params.day,
        onError: (error: any) => {
            handleMessageError(error);
        },
    });

    useEffect(() => {
        if (params.day) {
            refetch();
        }
    }, [params, refetch]);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, []);

    return (
        <LayoutContent
            className="p-revenue"
            title={`LỊCH SỬ`}
            actionFilter={{
                title: 'Ngày',
                value: params.day,
                onChange: (data?: any) => setParams({ day: data }),
            }}
        >
            <FormProvider {...methods}>
                <Content data={revenue?.data} total={revenue?.total} isLoading={isLoading} />
            </FormProvider>
        </LayoutContent>
    );
};

export default Revenue;
